import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { withLayout } from 'hocs';

class JourneyRoute extends Component {
  render() {
    const RenderComponent = this.props.component;

    return <Route render={props => <RenderComponent {...props} />} />;
  }
}

export default withLayout('Journey')(JourneyRoute);



// WEBPACK FOOTER //
// ./src/routes/components/JourneyRoute/index.js